/**
 * @file format.ts
 * @description Чистые утилиты вокруг AccountContext — лейбл и landing-путь.
 *
 * Живут отдельно от компонентов, чтобы Vite Fast Refresh корректно работал
 * (правило react-refresh/only-export-components: файл с React-компонентом
 * не должен экспортировать ещё и обычные функции).
 */

import type { AccountContext } from "./types";

/** Человекочитаемая подпись для identity-widget и switcher. */
export function formatContextLabel(ctx: AccountContext | null): string {
  if (!ctx) return "Контекст не выбран";
  const scope = ctx.contextType === "PLATFORM" ? "Платформа" : `Магазин ${ctx.shop?.displayName ?? "—"}`;
  return `${scope} · ${ctx.role.displayName}`;
}

/** Куда вести после выбора контекста (или после login'а). */
export function landingPathFor(ctx: AccountContext): string {
  if (ctx.contextType === "PLATFORM") return "/platform";
  return `/shop/${ctx.shop?.slug ?? ""}`;
}
